export default {"src":"/_next/static/media/confirmation_number.fe0a7c84.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};